
import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../utils/apiCall";
import { toast } from "react-toastify";

const TippingFeeStore = create((set, get) => ({
    tippingFeeData: [],
    loading: false,
    error: false,
    statusFilter: "",
    tippingFeeDataForMT:[],

    fetchTippingFee: async (queryParams) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();
        try {
            const tippingData = await apiCall({
                url: `${API_BASE_URL1}MasterCreate/GetBulkTippingDetails?${queryString}`,
                method: "get",
                token: localStorage.getItem("token"),
            });
    
            set({ 
                tippingFeeData: Array.isArray(tippingData) ? tippingData : [], 
                // filteredObservations: Array.isArray(hygieneData) ? hygieneData : [],
                loading: false 
            });
    
        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            
            // Handle 404 (No Data Found) by setting an empty array
            if (error.response && error.response.status === 404) {
                set({ 
                    tippingFeeData: [], 
                    error: "No hygiene observations found.", 
                    loading: false 
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        } finally {
            set({ loading: false });
        }
    },
      // Create a New Transferstation Category with Validation Handling
        addTippingFeeData: async (newTippingData,tippingFeePerMT) => {
            set({ loading: true, error: null });
            try {
                const response = await axios.post(
                    `${API_BASE_URL1}MasterCreate/AddBulkTippingDetails?tippingFeePerMT=${tippingFeePerMT}`,
                    newTippingData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    }
                );
    
                set((state) => ({
                    tippingFeeData: [...state.tippingFeeData, response],
                    loading: false
                }));
                console.log(response)
    
                toast.success(response.data.message); 
                return { success: true };
    
            } catch (error) {
                console.error("Error adding observation:", error.response?.data || error.message);
    
                if (error.response?.status === 400) { // Handle validation errors
                    const validationErrors = error.response.data.errors || error.response.data;
    
                    if (typeof validationErrors === "object") {
                        let errorMessages = [];
    
                        Object.keys(validationErrors).forEach((key) => {
                            if (Array.isArray(validationErrors[key])) {
                                validationErrors[key].forEach((msg) => {
                                    errorMessages.push(msg);
                                });
                            } else {
                                errorMessages.push(validationErrors[key]);
                            }
                        });
    
                        errorMessages.forEach((msg) => toast.error(msg));
                        return { success: false, errors: validationErrors };
                    }
                }
    
                // Handle general errors
                const errorMessage = error.response?.data || "Failed to add observation";
                toast.error(errorMessage);
                set({ error: errorMessage, loading: false });
    
                return { success: false, errors: { general: errorMessage } };
            }
            finally {
                set({ loading: false });
            }
        },
    
        fetchTippingFeeForMT: async (queryParams) => {
            set({ loading: true, error: null });
            const queryString = new URLSearchParams(queryParams).toString();
            try {
                const tippingDataForMT = await apiCall({
                    url: `${API_BASE_URL1}MasterDetails/GetTippingFeeDetails`,
                    method: "get",
                    token: localStorage.getItem("token"),
                });
        
                set({ 
                    tippingFeeDataForMT: Array.isArray(tippingDataForMT) ? tippingDataForMT : [], 
                    // filteredObservations: Array.isArray(hygieneData) ? hygieneData : [],
                    loading: false 
                });
        
            } catch (error) {
                console.log(error.response?.data?.message || "Error fetching data");
                
                // Handle 404 (No Data Found) by setting an empty array
                if (error.response && error.response.status === 404) {
                    set({ 
                        tippingFeeDataForMT: [], 
                        error: "No hygiene observations found.", 
                        loading: false 
                    });
                } else {
                    set({ error: error.response?.data?.message || "Something went wrong", loading: false });
                }
            } finally {
                set({ loading: false });
            }
        },
      

}));

export default TippingFeeStore;
